import styled from "@emotion/styled";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import ListItemIcon from "@mui/material/ListItemIcon";
import Box from "@mui/material/Box";
import Layout from "components/structure/Layout";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  ListItemText,
} from "@mui/material";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import ProfileService from "services/ProfileService";
import { AuthData } from "auth/AuthWarpper";
import NoData from "assets/noData.svg";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import axios from "axios";
import ImportService from "services/ImportService";
import docEnabled from "assets/docEnabled.svg";
import docDisabled from "assets/docDisabled.svg";
import PaginationImport from "../Common/PaginationImport";
import CustomPagination from "../Common/CustomPagination";

const validationSchema = Yup.object({
  profileCode: Yup.string()
    .required("Profile Code is required")
    .max(50, "Profile Code must be less than 50 characters")
    .matches(
      /^[^\s]+(?: [^\s]+)*$/,
      "Profile Code is required and must not contain Extra spaces"
    ),
  profileName: Yup.string()
    .required("Profile Name is required")
    .max(50, "Profile Name must be less than 50 characters")
    .matches(
      /^[^\s]+(?: [^\s]+)*$/,
      "Profile Name is required and must not contain Extra spaces"
    ),
  profileAttributes: Yup.string().required("Attribute is required"),
  functionality: Yup.array()
    .min(1, "At least one item is required")
    .required("Functionality is required"),
});

const ViewContractLog = (props) => {
  const { state } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = AuthData();
  const [options, setOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  let year = "";
  const [yearReload, setYearReload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(7); // Num
  const [importData, setImportData] = useState([]);
  const [defaultFilter, setDefaultFilter] = useState('');
  const [selectedFilter, setSelectedFilter] = useState("");
  const [pageSize, setPageSize] = useState(20);

  const paginate = (pageNumber, itemsPerPage) => {
    getApiData(pageNumber - 1, itemsPerPage, id, defaultFilter);
  };

  const handleViewLogDetails = (id) => {
    let routeName = "viewContractDetails";
    navigate(`/${routeName}/${id}`);
  };

  
  const fetchData = async () => {
    try {
      const response = await ImportService.ExportAll({ ilHeaderId: id }, {
        responseType: 'blob' // Expecting the response as plain text (CSV content)
      });

      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }
      const fileContent = response.data;
      // Create a Blob from the text content
      const blob = new Blob([fileContent], { type: 'text/csv' }); // Ensure MIME type is 'text/csv'
      // Create a URL for the Blob and trigger a download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `export_log_${id}.csv`; // Set the file name for download
      document.body.appendChild(a); // Append the anchor to the document
      a.click(); // Trigger the download
      document.body.removeChild(a); // Remove the anchor from the document
      window.URL.revokeObjectURL(url); // Clean up the object URL
    } catch (error) {
      console.error('Error downloading file:', error);
      // Handle the error (e.g., show a message to the user)
    }
  };

  const logsDetails = {
    fileName: "",
    uploadedByUser: "",
    uploadStatus: "",
    comments: "",
    timestamp: "",
    success: "",
  };

  const [logsDetailsData, setLogsDetailsData] = useState(logsDetails);

  const data = [
    {
      id: 1,
      levelCode: "LC001",
      locationName: "Location A",
      parentLocationCode: "PL001",
      personName: "John Doe",
      batOneId: "BAT12345",
      status: "Active",
      operation: "Op A",
      errorDescription: "None",
    },
    {
      id: 2,
      levelCode: "LC002",
      locationName: "Location B",
      parentLocationCode: "PL002",
      personName: "Jane Smith",
      batOneId: "BAT12346",
      status: "Inactive",
      operation: "Op B",
      errorDescription: "Validation Error",
    },
    {
      id: 3,
      levelCode: "LC003",
      locationName: "Location C",
      parentLocationCode: "PL003",
      personName: "Michael Lee",
      batOneId: "BAT12347",
      status: "Active",
      operation: "Op C",
      errorDescription: "None",
    },
    // Add more mock data as needed
  ];

  const handleChange = (event) => {
    // setFetchError(false);
    year = event.target.value;
    setYearReload(true);
  };

  function formatNumber(num) {
    return String(num).padStart(2, "0");
  }

  const setColor = (status) => {
    switch (status) {
      case "Success":
        return "green";
      case "Failed":
        return "red";
      default:
        return "black";
    }
  };

  const checkSuccessOrFail = (status) => {
    switch (status) {
      case "Success":
        return "Success";
      case "Failed":
        return "Fail";
      default:
        return "Success";
    }
  };

  const checkActive = (status) => {
    switch (status) {
      case true:
        return "Yes";
      case false:
        return "No";
      default:
        return "Yes";
    }
  };

  const handleChangeFilter = (event) => {
    setSelectedFilter(event.target.value);
    if(event.target.value == 'Fail'){
      setDefaultFilter('Failed');
    } else if(event.target.value == 'Success') {
      setDefaultFilter('Success');
    } else {
      setDefaultFilter('');
    }
    if (event.target.value == "All") {
      getApiData(0, pageSize, id);
    } else if (event.target.value == "Success") {
      getApiData(0, pageSize, id, "Success");
    } else {
      getApiData(0, pageSize, id, "Failed");
    }
  };

  const { previousData, edit } = location.state || {};
  const { id } = useParams();

  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  const [formData, setFormData] = useState({
    profileCode: previousData?.profileCode || "",
    profileName: previousData?.profileName || "",
    profileAttributes: previousData?.attributes || "",
    isActive: previousData?.active == "Active" ? true : false || false,
    functionality: selected,
  });

  const getApiData = (pNumber, size, id, filter) => {
    setLoading(true);
    let entityName = "ImportContract";
    ImportService.FetchLogsList({
      entityName: entityName,
      pageNumber: pNumber,
      size: size,
      headerID: id,
      searchQuery: filter,
    })
      .then((res) => {
        let resp = res?.data?.response;
        setImportData(resp?.contractResponse);
        setCurrentPage(pNumber);
        setItemsPerPage(size);
        setTotalItems(res?.data?.response?.totalItems);
        setLoading(false);
      })
      .catch((error) => {
        setImportData([]);
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setSeverity("error");
        setLoading(false);
      });
  };

  useEffect(() => {
    if (location?.state) {
      setLogsDetailsData({
        fileName: location.state.fileName,
        uploadedByUser: location.state.uploadedBy,
        uploadStatus: location.state.uploadStatus,
        comments: location.state.comments,
        timestamp: location.state.timestamp,
        success: location.state.success + "/" + location.state.fail,
      });
    }
    if (id) {
      getApiData(0, pageSize, id);
    }
    if (location && location.pathname == "/addProfiles") {
      let p_name = formData.profileName;
      let p_attr = formData.profileAttributes;
      const result =
        mergeFirstCharacters(p_name) + mergeFirstCharacters(p_attr);
      const uniqueNumber = generateUniqueNumber();
      let numberStr = uniqueNumber.toString();
      if (numberStr.charAt(0) == "-") {
        numberStr = numberStr.replace(numberStr[0], "");
      }
      setFormData({
        ...formData,
        ["profileCode"]: `${result.toUpperCase()}${numberStr}`,
      });
    }
  }, [formData.profileName, formData.profileAttributes]);

  const mergeFirstCharacters = (str) => {
    const words = str.split(" ");
    const mergedCharacters = words.map((word) => word.charAt(0)).join("");
    return mergedCharacters;
  };

  function generateUniqueNumber() {
    const timestamp = new Date().getTime();
    const randomNumber = Math.floor(Math.random() * 1000000);
    const uniqueIdentifier = navigator.userAgent;
    const uniqueNumber = hashCode(timestamp + randomNumber + uniqueIdentifier);
    return uniqueNumber;
  }

  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash &= hash; // Convert to 32bit integer
    }
    return hash;
  }

  useEffect(() => {
    const fetchFunctionalityOptions = async () => {
      try {
        const response = await ProfileService.getFuntionalityOptions();

        if (edit === true) {
          setOptions([
            ...previousData.functionality,
            ...response.data.response.filter(
              (option) =>
                !previousData.functionality.some(
                  (existingOption) =>
                    existingOption.functionalityName ===
                    option.functionalityName
                )
            ),
          ]);

          // Initialize selected countries with countryArr
          const selectedOptions = previousData.functionality.filter((option) =>
            response.data.response.some(
              (selectedOption) =>
                selectedOption.functionalityName === option.functionalityName
            )
          );
          setSelected(selectedOptions);
          setFormData({
            ...formData,
            functionality: selectedOptions,
          });
        } else {
          setOptions(response.data.response);
        }
      } catch (error) {
        console.error("Error fetching functionality options:", error);
      }
    };

    fetchFunctionalityOptions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      setErrors({});
      await validationSchema.validate(formData, { abortEarly: false });

      const payload = {
        profileCode: formData.profileCode,
        profileName: formData.profileName,
        isActive: formData.isActive,
        profileAttribute: formData.profileAttributes,
        functionality: formData.functionality,
        createdByUser: user?.userName,
        modifiedByUser: user?.userName,
      };

      const response = await ProfileService.createProfileRegistration(payload);

      if (response.status === 201) {
        navigate("/manageProfiles");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        let newError = {};
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
        });
        setErrors(newError);
      } else {
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setSeverity("error");
        setLoading(false);
      }
    }
    setLoading(false);
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      setErrors({});
      await validationSchema.validate(formData, { abortEarly: false });

      const payload = {
        profileCode: formData.profileCode,
        profileName: formData.profileName,
        isActive: formData.isActive,
        profileAttribute: formData.profileAttributes,
        modifiedByUser: user.userName,
        profileId: id,
        functionality: formData.functionality,
      };

      const response = await ProfileService.updateProfileRegistration(payload);

      if (response.status === 200) {
        navigate("/manageProfiles");
        setSeverity("success");
        setMessage("Updated successfully");
        setOpenAlert(true);
      } else {
        console.error("Failed to update form");
        setSeverity("error");
        setMessage("Failed to update form");
        setOpenAlert(true);
        setLoading(false);
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        let newError = {};
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
        });
        setErrors(newError);
      } else {
        console.error("An error occurred while submitting the form:", error);
        setSeverity("error");
        setMessage("An error occurred while submitting the form");
        setOpenAlert(true);
      }
    }
    setLoading(false);
  };

  return (
    <>
      <Layout title="Agri360 ESG Portal">
        <div style={{ paddingBottom: "140px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Heading>Import Contracts</Heading>
            <Button
              sx={{
                borderRadius: 100,
                minWidth: 95,
                minHeight: 44,
                background: "#102A62",
              }}
              variant="contained"
              startIcon={<KeyboardBackspaceIcon />}
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </Box>
          <PaperContainer>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    File Name
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.fileName}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Uploaded By User
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.uploadedByUser}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "none" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Upload Status
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.uploadStatus}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Comments
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.comments}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Timestamp
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.timestamp}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Success/Fail
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.success}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </PaperContainer>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mt: 3,
            }}
          >
            <Box>
              <FormControl sx={{ m: 1, minWidth: { xs: 150, md: 300 } }}>
                <TextField
                  sx={{
                    width: { xs: "100%", md: "100%" },
                    "& .MuiOutlinedInput-root": {
                      height: "50px",
                      fontStyle: "normal",
                      fontWeight: "bold",
                      "& fieldset": {
                        borderColor: "#102A63 !important", // Default border color
                        borderWidth: "1px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#102A63 !important", // Hover border color
                        borderWidth: "1px",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#102A63", // Focused border color
                        borderWidth: "1px",
                      },
                      "&.Mui-disabled": {
                        backgroundColor: "#f5f5f7", // Background color for disabled state
                        "& input": {
                          color: "#000000", // Text color for disabled state
                          WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                          opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                          fontWeight: "600",
                          fontSize: "16px",
                        },
                        "& fieldset": {
                          borderColor: "transparent", // Optional: make border invisible when disabled
                        },
                      },
                    },
                  }}
                  select
                  value={selectedFilter}
                  onChange={handleChangeFilter}
                  // displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  label={selectedFilter ? "" : "Status"}
                >
                  <MenuItem value="All">
                    <b>All</b>
                  </MenuItem>
                  <MenuItem value="Success">
                    <b>Success </b>
                  </MenuItem>
                  <MenuItem value="Fail">
                    <b>Fail</b>
                  </MenuItem>
                </TextField>
              </FormControl>
            </Box>
            <Box>
              <Button
                sx={{
                  borderRadius: 2,
                  minWidth: 156,
                  minHeight: 44,
                  background: "#EF7D00",
                  marginTop: { xs: 1 },
                  marginLeft: { xs: 1 },
                  "&:hover": {
                    background: "#EF7D00",
                  },
                }}
                startIcon={loading && <CircularProgress size={20} />}
                variant="contained"
                onClick={fetchData}
                disabled={loading}
              >
                Export All
              </Button>
            </Box>
          </Box>
          <Box>
            {importData?.length > 0 && (
              <div
                className="import-table-container"
                style={{ paddingTop: "20px" }}
              >
                <table className="import-table">
                  <thead>
                    <tr className="HierarchyHead">
                      <th>Grower No</th>
                      <th>Contract No</th>
                      <th>Curing Tobacco Type</th>
                      <th>Grower Type</th>
                      <th>Active</th>
                      <th>Status</th>
                      <th>Operation</th>
                      <th>Error Description</th>
                      <th>View Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importData.map((row, index) => (
                      <tr key={index} className="import-table-row">
                        <td>{row?.legacyGrowingNo}</td>
                        <td>{row.legacyContractNO}</td>
                        <td>{row.tobaccoType}</td>

                        <td>{row.growerType}</td>
                        <td> {checkActive(row.isActive)}</td>
                        <td style={{ color: setColor(row?.status) }}>
                          {" "}
                          {checkSuccessOrFail(row.status)}
                        </td>
                        <td>{row.operation}</td>
                        <td> {row.errorDescription}</td>
                        <td>
                          <p onClick={() => handleViewLogDetails(row.iLdcID)}>
                            <img
                              style={{ cursor: "pointer" }}
                              src={docEnabled}
                            />
                          </p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {importData?.length == 0 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "40px",
                }}
              >
                <img src={NoData} style={{ height: "100px" }} alt="No Data" />
                <p>No Data Available</p>
              </Box>
            )}
          </Box>
        </div>
        <Box>
          {importData?.length > 0 && (
            <div style={{ position: "absolute", width: "96%", bottom: "70px" }}>
              {importData && (
                <CustomPagination
                itemsPerPage={itemsPerPage}
                setItemsPerPage = {(v)=>setItemsPerPage(v)}
                totalItems={totalItems}
                paginate={paginate}
                currentPage={currentPage}
                />
              )}
            </div>
          )}
        </Box>
      </Layout>
    </>
  );
};

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const PaperContainer = styled(Paper)`
  padding: 2rem 1rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0;
`;

export default ViewContractLog;
